import React from "react";
import { Sparkles, Compass } from "lucide-react";
import { getSettings } from "../services/settings";
import { useT } from "../services/i18n";

const CAPTURE_LABEL = { fr: "Capturer", en: "Capture", ru: "Запись" };

export default function TabBar({ active, onChange }) {
  const { t, lang } = useT();
  const hand = getSettings().hand;
  const order = hand === "right" ? ["explore", "capture"] : ["capture", "explore"];

  const labelFor = (k) =>
    k === "capture" ? CAPTURE_LABEL[lang] || CAPTURE_LABEL.fr : t("exp_title");
  const IconFor = { capture: Sparkles, explore: Compass };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-30 mx-auto flex max-w-md items-center justify-around border-t border-[var(--rmr-border)] bg-[var(--rmr-surface)]/90 px-2 pt-2 backdrop-blur-md"
      style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 8px)" }}
      data-testid="tab-bar"
    >
      {order.map((k) => {
        const Icon = IconFor[k];
        const isActive = active === k;
        return (
          <button
            key={k}
            onClick={() => onChange(k)}
            data-testid={`tab-${k}`}
            className="flex flex-1 flex-col items-center gap-1 rounded-2xl py-2 transition-colors"
          >
            <Icon
              size={22}
              strokeWidth={isActive ? 2.4 : 1.8}
              color={isActive ? "var(--rmr-accent)" : "var(--rmr-text-2)"}
            />
            <span
              className="text-xs font-medium transition-colors"
              style={{ color: isActive ? "var(--rmr-accent)" : "var(--rmr-text-2)" }}
            >
              {labelFor(k)}
            </span>
          </button>
        );
      })}
    </nav>
  );
}
